import { app } from "router/routes"
import { useNavigate } from "react-router-dom"


const useGoRegisterBtn = () => {
    const navigate = useNavigate()

    const goRegister = () => {
        // navigate(app.register)
        navigate(app.schoolRegistartion)
    }

    const goRegisterBtn = {
        color: "secondary",
        action: goRegister,
        label: "הרשמה",
        fullWidth: true
        // width: "200px"
    }

    return goRegisterBtn
}

export default useGoRegisterBtn